module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "pg7"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])])]), _c('a', {
    attrs: {
      "id": "pg7"
    }
  }), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "pg7"
    }
  }), _c('a', {
    attrs: {
      "href": "#/acknowledgement#Ack"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/introduction#Intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/part1#Part1"
    }
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" I. E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UREKA")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRINGS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter01#C1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. The Historic Crescent Hotel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter01#Sub1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Room 218: Michael’s Room")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter01#Sub2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Norman Baker’s Morgue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter01#Sub3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other Reported Activity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#C2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Historic Basin Park Hotel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#Sub1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Barefoot Ballroom")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#Sub2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other Ghostly Sightings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#C3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. St. Elizabeth of Hungary Catholic Church")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#C4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Palace Hotel and Bath House")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#C5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. The Rock House")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#C6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Other Eureka Springs Ghosts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/part2#Part2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" II. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVIL")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AR")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATTLEFIELDS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07#C7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Pea Ridge Battlefield")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07#Sub1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Elkhorn Tavern")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07#Sub2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("William’s Hollow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07#Sub3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other Battlefield Ghosts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter08#C8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Prairie Grove Battlefield")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter08#Sub1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Borden House")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter08#Sub2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ozark Village and Memorial Park")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "pg8"
    }
  }), _c('span', {
    attrs: {
      "href": "#/part3#Part3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" III. F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AYETTEVILLE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REA")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter09#C9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Civil War and National Cemeteries")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter09#Sub1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fayetteville National Cemetery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter09#Sub2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fayetteville Confederate Cemetery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#C10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Other Fayetteville Haunts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#Sub1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Arkansas Air and Military Museum")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#Sub2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Carnall Hall")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/part4#Part4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" IV. R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OGERS")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REA")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11#C11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Monte Ne")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12#C12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. War Eagle Mill")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/conclusion#Con",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/bibliography#Bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/abouttheauthor#Abo",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2b12612","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content.vue
// module id = 69
// module chunks = 0